import * as React from 'react';
import {
  Table,
  TableBody,
  TableRow,
  TableCell,
} from 'components/ui/table';
import { useInvoiceStore } from 'pages/tracking-v2/invoice-details-page/hooks';
import { Formatter } from 'utils';

const date = (date: string | null) => {
  return Formatter.date(date, { format: 'dd/MM/yyy HH:mm' });
};

const latLng = (lat: string, lng: string) => {
  return [lat, lng].filter(Boolean).join(', ');
};

export const OccurrencesList = () => {
  const { invoice } = useInvoiceStore();

  const occurrences = React.useMemo(() => {
    return invoice?.occurrences?.sort((a, b) => {
      return b.createdAt.localeCompare(a.createdAt);
    });
  }, [invoice?.occurrences]);

  return (
    <Table>
      <TableBody>
        {occurrences?.map((occ) => (
          <TableRow key={occ.id}>
            <TableCell className={'align-top w-[160px]'}>
              {date(occ.createdAt)}
            </TableCell>
            <TableCell className={'align-top w-[200px]'}>
              {occ?.invoiceGeolocation && latLng(
                occ.invoiceGeolocation.latitude,
                occ.invoiceGeolocation.longitude,
              )}
            </TableCell>
            <TableCell className={'align-top'}>
              {occ.occurrenceType.name}
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};